import React, { Component } from 'react';

// Compact multi-select checkbox dropdown with a "Select All" option.
// Controlled: parent owns `selected` (array of values) and receives changes via onChange.
class MultiSelectDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.wrapRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }

    handleOutsideClick = (e) => {
        if (this.wrapRef.current && !this.wrapRef.current.contains(e.target)) {
            this.setState({ open: false });
        }
    }

    toggleOpen = () => this.setState((s) => ({ open: !s.open }));

    isAllSelected = () => this.props.options.length > 0 && this.props.selected.length === this.props.options.length;

    toggleAll = () => {
        this.props.onChange(this.isAllSelected() ? [] : this.props.options.map((o) => o.value));
    }

    toggleOne = (value) => {
        const selected = this.props.selected;
        if (selected.includes(value)) {
            this.props.onChange(selected.filter((v) => v != value));
        } else {
            this.props.onChange([...selected, value]);
        }
    }

    toggleText = () => {
        const { options, selected } = this.props;
        if (options.length == 0) return "None";
        if (selected.length == options.length) return `All (${options.length})`;
        if (selected.length == 0) return "None";
        return `${selected.length} selected`;
    }

    render() {
        const { options, selected, label } = this.props;
        const { open } = this.state;

        return (
            <div className='rm-ms' ref={this.wrapRef}>
                <label className='rm-ms-label'>{label}</label>
                <button type='button' className={open ? "rm-ms-toggle open" : "rm-ms-toggle"} onClick={this.toggleOpen} disabled={options.length == 0}>
                    <span className='rm-ms-value'>{this.toggleText()}</span>
                    <i className={open ? "fas fa-chevron-up" : "fas fa-chevron-down"}></i>
                </button>
                {open ? (
                    <div className='rm-ms-menu'>
                        <label className='rm-ms-item rm-ms-all'>
                            <input type='checkbox' checked={this.isAllSelected()} onChange={this.toggleAll} />
                            <span>Select All</span>
                        </label>
                        {options.map((o, i) => (
                            <label className='rm-ms-item' key={i}>
                                <input type='checkbox' checked={selected.includes(o.value)} onChange={() => this.toggleOne(o.value)} />
                                <span>{o.label}</span>
                            </label>
                        ))}
                    </div>
                ) : ("")}
            </div>
        );
    }
}

export default MultiSelectDropdown;
